import React from 'react'
import Heading from '../../components/Heading'
import { useTranslation } from 'react-i18next'
import SettingsList from '../../compositions/Settings/SettingOverview/SettingsList/SettingsList'

const SettingsOverview: React.FC = () => {
    const { t } = useTranslation(['settings'])

    return (
        <>
            <Heading level={2} classes={'zr-my-4'}>
                {t('common.settings')}
            </Heading>
            <SettingsList />
        </>
    )
}

export default SettingsOverview
